import config from '../../config';
const { API_END_POINT } = config;

export default function NoCacheInterceptor() {
  'ngInject';

  const nonce = new Date().getTime();

  return {
    request(httpConfig) {
      if (__TEST__) {
        return httpConfig;
      }

      if (httpConfig.method === 'GET' && httpConfig.url.includes(API_END_POINT)) {
        httpConfig.params = httpConfig.params || {};
        httpConfig.params.nonce = nonce;
      }
      return httpConfig;
    },
  };
}
